import { Badge } from '@chakra-ui/react'
import { useSlaTimer } from '@/hooks/useSlaTimer'

export function TimerCell({
  requestedAt,
  acknowledgeDueAt,
}: {
  requestedAt: string
  acknowledgeDueAt?: string | null
}) {
  const { remainingText, isCritical, isExpired, overdueMs } = useSlaTimer(requestedAt, acknowledgeDueAt)

  if (isExpired) {
    const isSeverelyOverdue = overdueMs >= 5 * 60 * 1000
    return (
      <Badge colorScheme="red" fontWeight={isSeverelyOverdue ? 'bold' : 'semibold'} whiteSpace="nowrap">
        {remainingText}
      </Badge>
    )
  }
  if (isCritical) return <Badge colorScheme="orange" whiteSpace="nowrap">{remainingText}</Badge>
  return <Badge colorScheme="gray" whiteSpace="nowrap">{remainingText}</Badge>
}
